import useIsMobile from "../../../../hooks/device/useIsMobile";
import type { BonusXLogoProps } from "../../../blocks/BonusXLogo";
import { DefaultLogo } from "./default-logo";
import { SmallLogo } from "./small-logo";

export function MainLogo({ forceLogoExtended }: Pick<BonusXLogoProps, "forceLogoExtended">): JSX.Element {
  const isMobile = useIsMobile();
  const showSmallLogo = isMobile && !forceLogoExtended;

  return showSmallLogo ? <SmallLogo /> : <DefaultLogo />;
}
